import { getWhatsAppProviderLabel } from "../../constants/whatsappProviders";
import { i18n } from "../../translate/i18n";

/** Segundos → «45 s», «12 min», «3 h 20 min», «2 d 4 h». */
export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined) return "—";
  const s = Math.max(0, Math.round(Number(seconds)));
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return m % 60 ? `${h} h ${m % 60} min` : `${h} h`;
  const d = Math.floor(h / 24);
  return h % 24 ? `${d} d ${h % 24} h` : `${d} d`;
};

/** Minutos → «hace 5 min», «hace 3 h», «hace 12 d». */
export const formatAge = (minutes) => {
  if (minutes === null || minutes === undefined) return "";
  const m = Math.max(0, Number(minutes));
  if (m < 60) return i18n.t("reports.ago", { value: `${m} min` });
  if (m < 60 * 24) return i18n.t("reports.ago", { value: `${Math.floor(m / 60)} h` });
  return i18n.t("reports.ago", { value: `${Math.floor(m / 1440)} d` });
};

export const percent = (part, total) => (total > 0 ? Math.round((part / total) * 100) : 0);

/** Media de valoración 1–5 → «4,3» (un decimal, separador del idioma). */
export const formatRate = (rate) =>
  rate === null || rate === undefined
    ? "—"
    : Number(rate).toLocaleString(i18n.language || undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const channelLabel = (provider) => getWhatsAppProviderLabel(provider);

// Paleta categórica estable para los gráficos (orden fijo: el mismo dato, el mismo color).
export const CHART_COLORS = ["#2563EB", "#16A34A", "#F59E0B", "#DB2777", "#7C3AED", "#0891B2", "#DC2626", "#64748B"];
